import { c as _c } from "react/compiler-runtime";
import { useProduct } from 'modules/products/hooks/use-products';
import { useRouter } from 'next/router';
import React from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { ChevronDownIcon } from '@systemeio/ui/icons';
function ProductBreadcrumbs() {
  const $ = _c(5);
  const router = useRouter();
  const {
    productId
  } = router.query;
  const {
    data: product
  } = useProduct(Number(productId));
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] !== product || $[1] !== t) {
    t0 = product && <div className="text-text-primary mb-2 flex items-center gap-2 px-6 text-xl font-semibold"><div className="cursor-pointer"><LinkWithoutPrefetch href="/products">{t("dashboard.products.list.title")}</LinkWithoutPrefetch></div><ChevronDownIcon className="rotate-[-90deg]" width="25px" height="8px" /><div className="cursor-pointer">{product.name}</div></div>;
    $[0] = product;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t0) {
    t1 = <>{t0}</>;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
export default ProductBreadcrumbs;